module.exports = __webpack_public_path__ + "static/media/water-and-fireproof-safes.ac6ec6e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/hero/water-and-fireproof-safes.jpg
// module id = 1252
// module chunks = 0